import ActivityIndicator from '../ActivityIndicator';
import classNames from 'classnames';

type Props = {
  text: string;
  variant: 'primary' | 'secondary' | 'tertiary' | 'tertiary-danger';
  border?: boolean;
  disabled?: boolean;
  onPress: () => void;
  isLoading?: boolean;
  containerClassName?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  align?: 'text-center' | 'text-left' | 'text-right';
  size?: 'small' | 'large';
};
const DesignSystemButton = ({
  text,
  variant,
  border = false,
  disabled = false,
  onPress,
  isLoading,
  containerClassName,
  leftIcon = <div />,
  rightIcon = <div />,
  align = 'text-center',
  size = 'large'
}: Props) => {
  const btnDisabled = disabled || isLoading;
  return (
    <div
      onClick={onPress}
      className={classNames('cursor-pointer hover:opacity-80', {
        'pointer-events-none': btnDisabled,
        'pointer-events-auto': !btnDisabled
      })}
    >
      <div
        className={classNames(
          'flex items-center justify-center rounded-[8px]',
          {
            'bg-[#3EA6FF]': variant === 'primary',
            'bg-[#444444]': btnDisabled,
            'border-[0.5px] border-[#3EA6FF4D]':
              variant === 'secondary' && border,
            'px-md py-xs': size === 'small',
            'px-lg py-md': size === 'large'
          },
          containerClassName
        )}
      >
        {isLoading && (
          <ActivityIndicator
            color={btnDisabled ? '#94969C' : '#272727'}
            className="mr-2"
          />
        )}
        {leftIcon}
        <div
          className={classNames(
            'mx-[4px] text-center font-[500] text-[#272727] whitespace-nowrap',
            align,
            {
              'text-[#94969C]': disabled,
              'text-[#409EF2]':
                variant === 'secondary' || variant === 'tertiary',
              'text-[#E94860]': variant === 'tertiary-danger',
              'text-normal': variant === 'tertiary',
              'text-xs leading-xs': size === 'small',
              'text-sm leading-sm': size === 'large'
            }
          )}
        >
          {text}
        </div>
        {rightIcon}
      </div>
    </div>
  );
};

export default DesignSystemButton;
